import { useQuery } from '@tanstack/react-query';
import { FeedbackInfoBox } from 'components';
import { useLocation } from 'react-router-dom';
import { useAPI } from 'stores';
import { MotionWrapper } from 'utils';

const FeedbackDetail = () => {
	// 	Get Feedback id from the state set in <FeedbackTag /> (Set at navigate()).
	const { state } = useLocation();
	const id = state?.id;

	const { getFeedbackDetail } = useAPI();

	// 	Assumption: Feedback Information is not going to change, thus there is no need to refetch. Optimize loading speed.
	const { data } = useQuery(
		['FeedbackDetail', id],
		async () => {
			if (!id) return null;
			return await getFeedbackDetail(id);
		},
		{ refetchOnWindowFocus: false, refetchOnMount: false }
	);

	if (!id) return <></>;

	return (
		<MotionWrapper>
			<FeedbackInfoBox feedback={data?.data} />
		</MotionWrapper>
	);
};

export default FeedbackDetail;
